<template>
  <div class>
    <section id="PublishApp">
      <div class>
        <div class="uk-section">
          <div class="uk-container">
            <div class="uk-grid-large uk-grid" data-uk-grid>
              <div class="uk-width-1-1 uk-width-expand@m">
                <article class="uk-article">
                  <h1 class="uk-article-title">Publish Your App</h1>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="endpoint">
      <div class>
        <div class="uk-section">
          <div class="uk-container">
            <div class="uk-grid-large uk-grid" data-uk-grid>
              <div class="uk-width-1-1 uk-width-expand@m">
                <article class="uk-article">
                  <h2 class="uk-article-title">Endpoint URL generation</h2>
                  <p>When you finish building and testing your active app , make it available to your users by publishing it to the endpoint.</p>

                  <ol>
                    <li>
                      From the vertical menu, choose
                      <strong>Endpoints</strong>,
                    </li>
                    <li>
                      Then select
                      <strong>Publish</strong> in the top, right panel.
                    </li>
                    <li>Enter a description about your app (optional )</li>
                    <li>The table will be updated with the URL of your endpoint.</li>
                  </ol>

                  <img style="margin-left: 140px;" src="../../../assets/pic13.png" />
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="description">
      <div class>
        <div class="uk-section">
          <div class="uk-container">
            <div class="uk-grid-large uk-grid" data-uk-grid>
              <div class="uk-width-1-1 uk-width-expand@m">
                <article class="uk-article">
                  <h2 class="uk-article-title">Endpoint URL description</h2>
                  <p>When you finish publishing your active app , a URL will be generated.</p>
                  <img src="../../../assets/pic14.png" />

                  <table style="width:100%">
                    <tr>
                      <th>bot_name</th>
                      <td>the name of your bot</td>
                      <td>Auto generated and it is required.</td>
                    </tr>
                    <tr>
                      <th>id_bot</th>
                      <td>the ID of your bot</td>
                      <td>Auto generated and it is required.</td>
                    </tr>
                    <tr>
                      <th>switche</th>
                      <td>The translation can be "On" or "Off"</td>
                      <td>Auto generated and it is not required.</td>
                    </tr>
                    <tr>
                      <th>domaine</th>
                      <td>The domains of your App</td>
                      <td>Auto generated and it is not required.</td>
                    </tr>
                    <tr>
                      <th>text</th>
                      <td>The sentence you want send</td>
                      <td>Not auto generated and it is required.</td>
                    </tr>
                  </table>
                </article>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="publish">
      <div class="page-wrapper">
        <div class="uk-section">
          <div class="uk-container">
            <div class="uk-grid-large uk-grid" data-uk-grid>
              <div class="uk-width-1-1 uk-width-expand@m">
                <article class="uk-article">
                  <h2 class="uk-article-title">Endpoint URL - App integration</h2>
                  <h3>/Request (public_endpoint, Text)</h3>
                  <p>This endpoint retrieves all intents , entities , sentiments … from a sentence.</p>
                  <p>Text request works with any raw text.</p>
                  <p>
                    <span class="label label-post">GET</span>
                    <code
                      class="prettyprint"
                    >https://node2.mobilesupportbot.com:5051/testpublishmodel?bot_name=kikooo&id_bot=5dc4152e1846203528139032&switche=On&domaine=banque,Emploi,restauration-alimentation&text="your text here</code>
                  </p>
                </article>
              </div>
            </div>
          </div>
         <div class="dark-box">
          <div class="lang-selector">
                <a href="#" data-language-name="shell" class="active">shell</a>
                <a href="#" data-language-name="ruby" class="">ruby</a>
                <a href="#" data-language-name="python" class="">python</a>
                <a href="#" data-language-name="javascript" class="">javascript</a>
          </div>
      </div>
        </div>
      </div>
       
    </section>
  </div>
</template>

<script>
export default {};
</script>
<style scoped lang="sass">
.page-wrapper 
    position: relative;
    z-index: 10;
    background-color: #ffffff;
    min-height: 100%;
    padding-bottom: 1px;

.dark-box 
    width: 40%;
    background-color: #262728;
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;

.uk-section
  margin-left: 70px;
  margin-top: 70px
.souspuce
  list-style-type: cercle;
.puce 
  list-style-type: disc;
.content .label-post 
  background: #309f85;
  color: #ffffff;
.content .label 
    padding: 2px 10px 4px;
    border-radius: 4px;
    font-size: 11px;
    line-height: 11px;
    font-weight: bold;
    width: 50px;

.content code 
  color: #af5757;
  background-color: rgba(0, 0, 0, 0.05);
  padding: 3px 4px;
  border-radius: 3px;





 
</style>


// WEBPACK FOOTER //
// src/components/Shared/Documentation/documetation.publish.vue